import React from "react";

const MAP = {
    Nuova: "bg-[#38BDF8]/10 text-[#0369A1] border-[#38BDF8]/30",
    "In revisione": "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30",
    "In attesa": "bg-slate-100 text-slate-700 border-slate-200",
    Escalation: "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
    Chiusa: "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/30",
};

export function ReviewStatusBadge({ status = "Nuova", className = "" }) {
    const v = MAP[status] || MAP.Nuova;
    return (
        <span
            data-testid="review-status-badge"
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${v} ${className}`}
        >
            {status}
        </span>
    );
}

export default ReviewStatusBadge;
